import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Embed as EmbedComponent } from './Embed';
export const Embed = Node.create({
    name: 'embed',
    inline: false,
    group: 'block',
    draggable: true,
    addOptions() {
        return {
            HTMLAttributes: {},
            embeds: [],
            getEmbed: undefined,
        };
    },
    addAttributes() {
        return {
            embed: {
                default: undefined,
                rendered: false,
            },
            url: {
                default: undefined,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'div[data-type=embed]',
                getAttrs: dom => {
                    var _a;
                    if (typeof dom === 'string')
                        return {};
                    const element = dom;
                    const id = element.getAttribute('data-id');
                    const url = element.getAttribute('data-embed-url');
                    const embed = (_a = this.options.embeds) === null || _a === void 0 ? void 0 : _a.find(e => e.id === id);
                    if (!embed && !url)
                        return {};
                    return {
                        url,
                        embed,
                    };
                },
            },
        ];
    },
    renderHTML({ node }) {
        const { embed, url } = node.attrs;
        if (!embed && !url)
            return ['div'];
        return [
            'div',
            {
                'data-type': 'embed',
                'data-id': embed === null || embed === void 0 ? void 0 : embed.id,
                'data-embed-url': url || (embed === null || embed === void 0 ? void 0 : embed.url),
            },
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(EmbedComponent);
    },
    addCommands() {
        return {
            setEmbed: attrs => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs,
                });
            },
            removePreview: embed => ({ chain }) => {
                const { url } = embed;
                return chain()
                    .deleteNode('embed')
                    .insertLink({ href: url })
                    .insertContent(' ')
                    .run();
            },
        };
    },
});
//# sourceMappingURL=index.js.map